module.exports = __webpack_public_path__ + "img/components (20).2bed37c0.png";